import { useTranslation } from 'react-i18next';
import { useEditorRef } from 'platejs/react';
import MenuItem from '@mui/material/MenuItem';

import { options } from 'common/components/ContentEditor/options';

import { EmbedDialog } from './EmbedDialog';
import { useEmbedDialogState } from './useEmbedDialogState';

interface IProps {
    media_embed?: typeof options.media_embed;
}

export const BlockMenuEmbed = ({
    media_embed: _media_embed = options.media_embed,
}: IProps) => {
    const [translate] = useTranslation();
    const editor = useEditorRef();
    const { open, initialValue, onTrigger, onClose, onSubmit } =
        useEmbedDialogState(editor);

    return (
        <>
            <MenuItem
                onClick={(event) => {
                    event.preventDefault();
                    onTrigger();
                }}
            >
                {translate('edit')}
            </MenuItem>
            <EmbedDialog
                initialValue={initialValue}
                open={open}
                onClose={onClose}
                onSubmit={onSubmit}
            />
        </>
    );
};
